import { useEffect, useRef } from "react";
import { logOut } from "../Redux/Auth/operations";
import useAuth from "../Redux/useAuth";
import { useAppDispatch } from "../Redux/store";
import { useNavigate } from "react-router-dom";

export const useTokenExpiration = () => {
  const { tokenAccount, idUser } = useAuth();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const hasLoggedOut = useRef(false);

  useEffect(() => {
    if (!tokenAccount || hasLoggedOut.current) return;

    try {
      const tokenData = JSON.parse(atob(tokenAccount.split(".")[1]));
      const expTime = tokenData.exp * 1000;
      const currentTime = Date.now();

      const handleLogout = () => {
        if (hasLoggedOut.current) return;
        hasLoggedOut.current = true;

        dispatch(logOut(idUser || ""));
        navigate("/sign-in", { replace: true });
      };

      if (expTime < currentTime) {
        handleLogout();
        return;
      }

      const timeout = setTimeout(handleLogout, expTime - currentTime);

      return () => clearTimeout(timeout);
    } catch (error) {
      console.error("Invalid token:", error);

      if (!hasLoggedOut.current) {
        hasLoggedOut.current = true;
        dispatch(logOut(idUser || ""));
        navigate("/sign-in", { replace: true });
      }
    }
  }, [tokenAccount, dispatch, navigate, idUser]);
};